/* Built In Imports */

/* External Imports */
import { Box, Center } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import TabGroupV2 from '@shi/components/Tabs/TabGroupV2';
import SingleLineText from '@shi/components/Text/SingleLineText';
import SectionTitle from '@shi/components/headings/SectionTitle';
import SadhanaContentSt from '@shi/styleData/SadhanaContentSt';
/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const SadhanaDetailsNew = ({ sectionContent, region, lang }) => {
  return (
    <Box px="16px" py={{ base: '20px', md: '40px' }}>
      <Center flexDirection="column">
        <SectionTitle titleObj={sectionContent[0]} />
      </Center>
      <SingleLineText
        sectionContent={sectionContent[1]}
        lang={lang}
        region={region}
        mx="auto"
        textAlign="center"
        my={{ base: '20px', md: '35px' }}
        color="#000"
        {...SadhanaContentSt[lang].eligibilityText}
        fontSize="18px"
      />
      <Box maxW={870} w="100%" mx="auto">
        <TabGroupV2
          sectionContent={sectionContent[2]}
          lang={lang}
          region={region}
        />
      </Box>
    </Box>
  );
};

export default SadhanaDetailsNew;
